import React from "react";
import {connect} from "react-redux";
import {FlatList, StyleSheet, View} from "react-native";
import ContactListItem from "./ContactListItem";


class ContactList extends React.Component{
    render() {
	const search_text = this.props.search.toUpperCase();

	let filtered_users = this.props.contacts;

	if (search_text !== "") {
	  filtered_users = filtered_users.filter((user) => {
	    (user.firstname.toUpperCase() + " " + user.lastname.toUpperCase())
	    .includes(search_text)
	  })
	}

        return (
            <View style={this.props.style}>
                <FlatList
                    data={filtered_users}
                    keyExtractor={(item,index)=>index.toString()}
                    renderItem={(item)=><ContactListItem addCommentMention={this.props.addCommentMention} search={this.props.search} contact={item.item} /> } />
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(ContactList);
